// extracted by mini-css-extract-plugin
module.exports = {"bg":"e_g2","border":"e_h2"};